import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';

export default function DepartmentCarousel({ data }) {
  const [visibleItems, setVisibleItems] = useState({});
  /** Slider Settings **/
  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        'cs_slider_prev cs_center' +
        (currentSlide === 0 ? ' slick-disabled' : '')
      }
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
    >
      <img src="images/icons/left_arrow_blue.svg" alt="Icon" />
    </div>
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        'cs_slider_next cs_center' +
        (currentSlide === slideCount - 1 ? ' slick-disabled' : '')
      }
      aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
    >
      <img src="images/icons/right_arrow_blue.svg" alt="Icon" />
    </div>
  );
  const settings = {
    dots: false,
    // prevArrow: <SlickArrowLeft />,
    // nextArrow: <SlickArrowRight />,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 4000,
    speed: 1000,
    slidesToShow: 4,
    swipeToSlide: true,
  };
  useEffect(() => {
    // Trigger pop-up animation for each item with a slight delay
    data?.forEach((_, index) => {
      setTimeout(() => {
        setVisibleItems(prev => ({ ...prev, [index]: true }));
      }, index * 150);
    });
  }, [data]);

  return (
    <>
      <style>
        {`
          @keyframes popUp {
            0% {
              transform: scale(0.8) translateY(20px);
              opacity: 0;
            }
            50% {
              transform: scale(1.05) translateY(-5px);
            }
            100% {
              transform: scale(1) translateY(0);
              opacity: 1;
            }
          }
          .cs_department_animated {
            animation: popUp 0.6s ease-out forwards;
          }
        `}
      </style>
      <Slider
        {...settings}
        className="cs_gap_20 cs_cs_slider_navigation_1 cs_department_carousel"
      >
        {data?.map((item, index) => (
          <div key={index}>
            <Link
              to={item.href}
              className={`cs_department cs_shadow_1 cs_radius_20 ${visibleItems[index] ? 'cs_department_animated' : ''}`}
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.3)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255, 255, 255, 0.5)',
                opacity: visibleItems[index] ? 1 : 0,
                transition: 'all 0.3s ease'
              }}
            >
              <>
                <img src={item.iconUrl} alt="Icon" />
                <p className="cs_department_title cs_medium cs_heading_color cs_fs_20 mb-0">
                  {item.title}
                </p>
              </>
            </Link>
          </div>
        ))}
      </Slider>
    </>
  );
}
